import Vue from 'vue';
import Vuetify from 'vuetify';
import es from 'vuetify/es5/locale/es'
import en from 'vuetify/es5/locale/en'
import 'vuetify/dist/vuetify.min.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@fortawesome/fontawesome-free/css/all.css'

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#0091FF',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#EA5455',
        info: '#2196F3',
        success: '#28C76F',
        warning: '#FF9F43',
        default: '#9E9E9E'
      },
    },
  },
  icons: {
    iconfont: 'md' || 'fa',
  },
  lang: {
    locales: { es, en },
    current: 'es'
  },
});
